module.exports = __webpack_public_path__ + "static/feature-autocomplete-b1c06f4cc76e963f440c1c403120069b.mp4";